// extracted by mini-css-extract-plugin
export var companyAddress = "layout-module--companyAddress--d9cba";
export var content = "layout-module--content--2bfc1";
export var footer = "layout-module--footer--ad7d0";
export var footerInMobile = "layout-module--footerInMobile--7003e";
export var footerWrapper = "layout-module--footerWrapper--c59a0";
export var siteInfo = "layout-module--siteInfo--30d4f";